import PostDocUploadFormModel from "./PostDocUploadFormModel";
const {
  formField: {
    // info
    statementReportGuideline,
    //info

    sendingFellowshipReport,
    mainResearchArea,
    researchTitleEnglish,
    progressCommencementFellowship,
    presentProgressResearchProject,

    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
    whatYourStatus,
    AssessMainProgressAchieved,
    ListJournalSubject,
    researchPlanRelevantIndicates,
    additionalInformNote,
    additionalDocument,
    //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA

    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
    submissionStatus,
    submitDate,
    receivedDate,
    revisedDate,
    articleTitle,
    manuscriptID,
    typeManuscript,
    journal,
    subjectAreaCategory,
    journalRanking,
    authors,
    firstAuthorName,
    correspondingAuthorName,
    coauthorAbroadPublication,
    coauthorName,
    coResearcherUniversityInstituteName,
    coResearcherUniversityInstituteRanking,
    supportedSecondCenturyFund,
    uploadManuscript,
    documentsShowingsSubmission,
    attachEvidenceTier1Paper,
    attachEvidenceUniversityInstituteRanking,
    additionalInformNoteSecB,
    additionalDocumentSecB,
    //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB

    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC
    receivedDateSecC,
    submitDateSecC,
    acceptedDateSecC,
    revisedDateSecC,
    articleTitleSecC,
    manuscriptIDSecC,
    typeManuscriptSecC,
    journalSecC,
    subjectAreaCategorySecC,
    journalRankingSecC,
    authorsSecC,
    firstAuthorNameSecC,
    correspondingAuthorNameSecC,
    coauthorAbroadPublicationSecC,
    coauthorNameSecC,
    coResearcherUniversityInstituteNameSecC,
    coResearcherUniversityInstituteRankingSecC,
    supportedSecondCenturyFundSecC,
    uploadManuscriptSecC,
    documentsShowingsSubmissionSecC,
    publicationAcceptedEvidenceSecC,
    attachEvidenceTier1PaperSecC,
    attachEvidenceUniversityInstituteRankingSecC,
    additionalInformNoteSecC,
    additionalDocumentSecC,
    //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC

    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
    receivedDateSecD,
    submitDateSecD,
    acceptedDateSecD,
    revisedDateSecD,
    publishedDateSecD,
    articleTitleSecD,
    manuscriptIDSecD,
    typeManuscriptSecD,
    journalSecD,
    subjectAreaCategorySecD,
    journalRankingSecD,
    authorsSecD,
    firstAuthorNameSecD,
    correspondingAuthorNameSecD,
    coauthorAbroadPublicationSecD,
    coauthorNameSecD,
    coResearcherUniversityInstituteNameSecD,
    coResearcherUniversityInstituteRankingSecD,
    supportedSecondCenturyFundSecD,
    uploadManuscriptSecD,
    documentsShowingsSubmissionSecD,
    publicationAcceptedEvidenceSecD,
    attachEvidenceTier1PaperSecD,
    attachEvidenceUniversityInstituteRankingSecD,
    additionalInformNoteSecD,
    additionalDocumentSecD
    //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
  }
} = PostDocUploadFormModel;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // info
  [statementReportGuideline.name]: "",
  //info

  [sendingFellowshipReport.name]: "",
  [mainResearchArea.name]: "",
  [researchTitleEnglish.name]: "",
  [progressCommencementFellowship.name]: "",
  [presentProgressResearchProject.name]: "",

  //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA
  [whatYourStatus.name]: "",
  [AssessMainProgressAchieved.name]: "",
  [ListJournalSubject.name]: "",
  [researchPlanRelevantIndicates.name]: null,
  [additionalInformNote.name]: "",
  [additionalDocument.name]: null,
  //secAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA

  //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB
  [submissionStatus.name]: "",
  [submitDate.name]: "",
  [receivedDate.name]: "",
  [revisedDate.name]: "",
  [articleTitle.name]: "",
  [manuscriptID.name]: "",
  [typeManuscript.name]: "",
  [journal.name]: "",
  [subjectAreaCategory.name]: "",
  [journalRanking.name]: "",
  [authors.name]: "",
  [firstAuthorName.name]: "",
  [correspondingAuthorName.name]: "",
  [coauthorAbroadPublication.name]: "",
  [coauthorName.name]: "",
  [coResearcherUniversityInstituteName.name]: "",
  [coResearcherUniversityInstituteRanking.name]: "",
  [supportedSecondCenturyFund.name]: "",
  [uploadManuscript.name]: null,
  [documentsShowingsSubmission.name]: null,
  [attachEvidenceTier1Paper.name]: null,
  [attachEvidenceUniversityInstituteRanking.name]: null,
  [additionalInformNoteSecB.name]: "",
  [additionalDocumentSecB.name]: null,
  //secBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBBB

  //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC
  [receivedDateSecC.name]: "",
  [submitDateSecC.name]: "",
  [acceptedDateSecC.name]: "",
  [revisedDateSecC.name]: "",
  [articleTitleSecC.name]: "",
  [manuscriptIDSecC.name]: "",
  [typeManuscriptSecC.name]: "",
  [journalSecC.name]: "",
  [subjectAreaCategorySecC.name]: "",
  [journalRankingSecC.name]: "",
  [authorsSecC.name]: "",
  [firstAuthorNameSecC.name]: "",
  [correspondingAuthorNameSecC.name]: "",
  [coauthorAbroadPublicationSecC.name]: "",
  [coauthorNameSecC.name]: "",
  [coResearcherUniversityInstituteNameSecC.name]: "",
  [coResearcherUniversityInstituteRankingSecC.name]: "",
  [supportedSecondCenturyFundSecC.name]: "",
  [uploadManuscriptSecC.name]: null,
  [documentsShowingsSubmissionSecC.name]: null,
  [publicationAcceptedEvidenceSecC.name]: null,
  [attachEvidenceTier1PaperSecC.name]: null,
  [attachEvidenceUniversityInstituteRankingSecC.name]: null,
  [additionalInformNoteSecC.name]: "",
  [additionalDocumentSecC.name]: null,
  //secCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCCC

  //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
  [receivedDateSecD.name]: "",
  [submitDateSecD.name]: "",
  [acceptedDateSecD.name]: "",
  [revisedDateSecD.name]: "",
  [publishedDateSecD.name]: "",
  [articleTitleSecD.name]: "",
  [manuscriptIDSecD.name]: "",
  [typeManuscriptSecD.name]: "",
  [journalSecD.name]: "",
  [subjectAreaCategorySecD.name]: "",
  [journalRankingSecD.name]: "",
  [authorsSecD.name]: "",
  [firstAuthorNameSecD.name]: "",
  [correspondingAuthorNameSecD.name]: "",
  [coauthorAbroadPublicationSecD.name]: "",
  [coauthorNameSecD.name]: "",
  [coResearcherUniversityInstituteNameSecD.name]: "",
  [coResearcherUniversityInstituteRankingSecD.name]: "",
  [supportedSecondCenturyFundSecD.name]: "",
  [uploadManuscriptSecD.name]: null,
  [documentsShowingsSubmissionSecD.name]: null,
  [publicationAcceptedEvidenceSecD.name]: null,
  [attachEvidenceTier1PaperSecD.name]: null,
  [attachEvidenceUniversityInstituteRankingSecD.name]: null,
  [additionalInformNoteSecD.name]: "",
  [additionalDocumentSecD.name]: null
  //secDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDDD
};
